export function organizeAccountsStructure(accounts) {
    const accountMap = new Map();
    accounts.forEach((account) => {
        var _a;
        const parentAccountId = (_a = account.parentAccount) === null || _a === void 0 ? void 0 : _a.id;
        if (!parentAccountId) {
            accountMap.set(account.id, [account]);
        }
        if (parentAccountId) {
            const parentAccount = accountMap.get(parentAccountId) || [];
            parentAccount.push(account);
            parentAccount.sort((a, b) => {
                if (!a.parentAccount || !b.parentAccount) {
                    return 1;
                }
                return a.normalizedName.localeCompare(b.normalizedName);
            });
            accountMap.set(parentAccountId, parentAccount);
        }
    });
    return Array.from(accountMap.values()).flat();
}
//# sourceMappingURL=organizeAccountsStructure.js.map
// @zapier/universal-layout@11.4.2 (c660b09a7)
